<template>
    <div class="language-container">
        <div class="language-container-body">
            <img src="../../assets/icons/close_with_shadow.svg" class="language-container-img cancel-responsive" @click="actClosePopup"/>
            <p>{{ $t('Choose your Display Language') }}</p>
            <div v-for="language of languages" :key="language.key" :extra="language.isActive">
                <singleLanguage :language="language" @callbackLang="selectedLanguageArr"></singleLanguage>
            </div>
            <div class="language-button button-primary" @click="actSelectLaguage">{{ $t('PROCEED') }}</div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            languages: [],
        };
    },
    methods: {
        actClosePopup() {
            document.body.style.overflow = 'auto';
            this.$emit('cbSwitchLanguage');
        },
        actSelectLaguage() {
  document.body.style.overflow = 'auto';

  const defaultLanguage = window.PROVIDER_SETUP_CONFIG?.defaultLanguage || 'en';
  const selectedLang = this.languages.find(lang => lang.isActive)?.local || defaultLanguage;

  localStorage.setItem('setDisplayLanguageCode', selectedLang);
  this.$i18n.locale = selectedLang;

  let currentPath = this.$route.path;
  const languageCodes = this.languages.map(lang => lang.local);
  const pathSegments = currentPath.split('/').filter(segment => segment);

  if (pathSegments.length && languageCodes.includes(pathSegments[0])) {
    pathSegments.shift();
  }
  const cleanPath = pathSegments.length ? `/${pathSegments.join('/')}` : '/';
  const newPath = selectedLang === 'es' ? cleanPath : `/en${cleanPath === '/' ? '' : cleanPath}`;

  if (this.$route.path !== newPath) {
    this.$router.replace(newPath).catch(err => {
      if (err.name !== 'NavigationDuplicated') {
        console.warn('Navigation error:', err);
      }
    });
  }

  this.$emit('cbSwitchLanguage');
},
        selectedLanguageArr({ key, local, isActive }) {
            this.languages = this.languages.map(singleLang => ({
                ...singleLang,
                isActive: singleLang.key === key && singleLang.local === local ? isActive : false,
            }));
        },
    },
    mounted() {
        // Initialize languages
        this.languages = window.PROVIDER_SETUP_CONFIG?.language || [
            { local: 'en', key: 'en', title: 'English', icon: 'en-icon.png', isActive: true },
            { local: 'es', key: 'es', title: 'Español', icon: 'es-icon.png', isActive: false },
        ];
        const defaultLanguage = window.PROVIDER_SETUP_CONFIG?.defaultLanguage || 'en';

        // Determine selected language
        const pathSegments = this.$route.path.split('/').filter(segment => segment);
        let selectedLang = localStorage.getItem('setDisplayLanguageCode') || defaultLanguage;

        // Check if URL starts with a language code
        if (pathSegments.length && this.languages.some(lang => lang.local === pathSegments[0])) {
            selectedLang = pathSegments[0];
        }

        // Update languages array and set i18n locale
        this.languages = this.languages.map(lang => ({
            ...lang,
            isActive: lang.local === selectedLang,
        }));
        localStorage.setItem('setDisplayLanguageCode', selectedLang);
        this.$i18n.locale = selectedLang;

        // Normalize URLs
        const languageCodes = this.languages.map(lang => lang.local);
        const currentPath = this.$route.path;
        const cleanSegments = pathSegments.length && languageCodes.includes(pathSegments[0]) ? pathSegments.slice(1) : pathSegments;
        const cleanPath = cleanSegments.length ? `/${cleanSegments.join('/')}` : '/';

        // Spanish: redirect /es/* to /*; English: ensure /en/* prefix
        if (selectedLang === 'es' && pathSegments[0] === 'es') {
            this.$router.replace(cleanPath).catch(err => {
                if (err.name !== 'NavigationDuplicated') {
                    console.warn('Router error:', err);
                }
            });
        } else if (selectedLang === 'en' && currentPath !== `/en${cleanPath === '/' ? '' : cleanPath}`) {
            const newPath = `/en${cleanPath === '/' ? '' : cleanPath}`;
            this.$router.replace(newPath).catch(err => {
                if (err.name !== 'NavigationDuplicated') {
                    console.warn('Router error:', err);
                }
            });
        }
    },
    components: {
        singleLanguage: () => import('@/components/Language/SingleLanguage.vue'),
    },
};
</script>

<style lang="scss">
@import '@/sass/_variables.scss';
@import './LanguageModel.scss';
</style>